// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Ruib","requiredAsterisk":"Info_requiredAsterisk__2S20X"};